import { HEIDI_II_MASTER_FLAG_KEY } from '@/features/flags/heidi-work-umbrella';
import { posthog } from '@/features/flags/posthog-compat';
import { isTauri } from '@/tauri/utils';
import { projectsFlag, projectsWebFlag } from '@heidi/agents/flags';
import { readFlag } from '@heidi/runtime/feature-flags';

export const AGENT_HOME_V1_FLAG_KEY = 'release-scribe-enable-nav-v3';

/** Sync twin of `useIsAgentHomeV1Enabled`, for non-React callers such as `IS_SIDEBAR_PANEL_ENABLED`. */
export const isAgentHomeV1Enabled = (): boolean => {
  const projects = isTauri() ? projectsFlag : projectsWebFlag;
  return (
    posthog.isFeatureEnabled(AGENT_HOME_V1_FLAG_KEY) === true &&
    (posthog.isFeatureEnabled(HEIDI_II_MASTER_FLAG_KEY) === true ||
      readFlag(projects.key, projects.defaultValue))
  );
};
